import React from 'react'
import useMediaQuery from '../hooks/useMediaQuery'
import { motion } from 'framer-motion'
import MessiImg from '../images/messi.jpg'
import LeagueImg from '../images/laliga.jpg'
import UnitedImg from '../images/united.jpg'
import { Link } from 'react-router-dom'
import { useContext } from 'react'
import { SelectedPageContext } from '../App'

const Type = () => {
  const { setSelectedPage } = useContext(SelectedPageContext)
  const isAboveLarge = useMediaQuery('(min-width: 1060px)')
  return (
    <section className='pt-16  mx-10 mb-10 '>
      {/* CONTAINER */}
      <div className=' md:flex justify-center items-center mt-16  gap-20 '>
        {/* LEAGUES  */}
        {/* PLAYERS */}
        <motion.div
          className='mt-5 md:w1/2 lg:w-1/3 '
          initial='hidden'
          whileInView='visible'
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <div class='mx-auto rounded-xl overflow-hidden shadow-lg  bg-violet-400 hover:bg-violet-600'>
            <img className=' h-[350px] w-full' src={MessiImg} />
            <div class='px-6 py-4'>
              <Link
                to={'/players'}
                class='font-bold text-xl mb-2 flex justify-center text-white'
                onClick={() => {
                  setSelectedPage('players')
                }}
              >
                Players stats
              </Link>
            </div>
          </div>
        </motion.div>

        {/* TEAMS */}
        <motion.div
          className=' mt-5 md:w1/2 lg:w-1/3 '
          initial='hidden'
          whileInView='visible'
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <div class='mx-auto rounded-xl overflow-hidden shadow-lg  bg-violet-400 hover:bg-violet-600'>
            <img className=' h-[350px] w-full' src={LeagueImg} />
            <div class='px-6 py-4'>
              <Link
                to={'/leagues'}
                class='font-bold text-xl mb-2 flex justify-center text-white'
                onClick={() => {
                  setSelectedPage('leagues')
                }}
              >
                Leagues stats
              </Link>
            </div>
          </div>
        </motion.div>

        {/* PLAYERS */}
        <motion.div
          className='mt-5 md:w1/2 lg:w-1/3 '
          initial='hidden'
          whileInView='visible'
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <div class='mx-auto rounded-xl overflow-hidden shadow-lg  bg-violet-400 hover:bg-violet-600'>
            <img className=' h-[350px] w-full' src={UnitedImg} />
            <div class='px-6 py-4'>
              <Link
                to={'/teams'}
                class='font-bold text-xl mb-2 flex justify-center text-white'
                onClick={() => {
                  setSelectedPage('teams')
                }}
              >
                Teams stats
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default Type
